import React from 'react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { bonuses, offer } from '../data/offer';
export function Bonuses() {
  return <section className="bg-ivory-2 px-5 py-14" data-id="element-20" data-mp="au1wqu68osm2">
      <SectionHeading eyebrow="In regalo con il pack" title={`+ ${offer.bonusCount} bonus`} accent="inclusi gratis" sub="Inclusi gratuitamente se ordini oggi, prima della fine del conto alla rovescia." data-id="element-21" data-mp="at8tw4aein97" />
      <div className="mt-9 space-y-4" data-id="element-22" data-mp="5w8n1r5q9gh1">
        {bonuses.map((b, i) => <Reveal key={b.number} delay={i * 0.04} data-id="element-23" data-mp="3o1v6kim4xyqq" data-mpi={i}>
            <article className="rounded-2xl border border-ivory-line bg-ivory-white p-4 shadow-soft" data-id="element-24" data-mp="3o36bwmv8bejy">
              <div className="flex gap-4" data-id="element-25" data-mp="3t0ycs6duqb0a">
                <img src={b.cover} alt={`Copertina del bonus ${b.number}: ${b.title}`} className="h-32 w-28 shrink-0 rounded-xl object-cover" data-id="element-26" data-mp="1mai4007n42xu" />
                <div className="flex min-w-0 flex-col" data-id="element-27" data-mp="3idmytxc3p7g2">
                  <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-wood-dark" data-id="element-28" data-mp="3ic3h02asqoc6">
                    Bonus {b.number} · PDF
                  </p>
                  <h3 className="mt-1 font-display text-xl uppercase leading-[1.08] text-ink" data-id="element-29" data-mp="3r5gk1x2kr6bz">{b.title}</h3>
                  <p className="mt-auto flex items-baseline gap-2.5 pt-2" data-id="element-30" data-mp="3n5ogxzvy9se0">
                    <span className="text-sm text-ink-muted line-through" data-id="element-31" data-mp="2zglqq3n92r7w">{b.value}</span>
                    <span className="rounded-full bg-leaf-bg px-2.5 py-0.5 text-xs font-bold text-leaf-dark" data-id="element-32" data-mp="2uh967pjupw8h">GRATIS</span>
                  </p>
                </div>
              </div>
              <p className="mt-3.5 text-[14px] leading-relaxed text-ink-body" data-id="element-33" data-mp="33hfe8vws6409">{b.description}</p>
            </article>
          </Reveal>)}
      </div>
      <InlineCta label="Voglio libro + 5 bonus" data-id="element-34" data-mp="no6q9kunvaoc" />
    </section>;
}